console.log('Carousel script loaded', document.querySelectorAll('[data-pc-carousel]').length);
function initCarousel(carousel) {
  if (carousel._pcInit) return;
  carousel._pcInit = true;

  const track = carousel.querySelector('[data-pc-track]');
  const dots = carousel.querySelectorAll('[data-pc-dot]');
  const prevBtn = carousel.querySelector('[data-pc-prev]');
  const nextBtn = carousel.querySelector('[data-pc-next]');
  let current = 0;
  const total = carousel.querySelectorAll('.pc-carousel__slide').length;

  if (total <= 1) return;

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
  }

  prevBtn?.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    goTo(current - 1);
  });

  nextBtn?.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    goTo(current + 1);
  });

  dots.forEach(dot => dot.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    goTo(parseInt(dot.dataset.pcDot));
  }));

  let startX = 0;
  track.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
  }, { passive: true });

  track.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      e.preventDefault();
      goTo(current + (diff > 0 ? 1 : -1));
    }
  });
}

function initAll() {
  document.querySelectorAll('[data-pc-carousel]').forEach(initCarousel);
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

// Observar cambios en el DOM para carruseles que se agreguen después
const observer = new MutationObserver(() => {
  document.querySelectorAll('[data-pc-carousel]').forEach(initCarousel);
});

observer.observe(document.body, { childList: true, subtree: true });
